import * as React from 'react';
import { UitkCardPlaceholder } from 'uitk-react-cards';
import { UitkSpacing } from 'uitk-react-spacing';
export var PlaceholderCard = function (_a) {
  var index = _a.index,
    className = _a.className;
  return React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'two',
      blockend: 'one'
    }
  }, React.createElement(UitkCardPlaceholder, {
    className: className,
    startPhase: index % 2 === 0 ? 'dark' : 'light',
    "data-testid": "placeholder-card"
  }));
};